import type { ReactNode } from 'react';
import { ShieldCheckIcon } from '@heroicons/react/24/outline';

interface LoginPageProps {
  appName: string;
  appIcon: ReactNode;
  basePath: string;
}

/**
 * Cloudflare Access normally authenticates before this page is served. The
 * button is a recovery path for an expired Access session.
 */
export function LoginPage({ appName, appIcon, basePath }: LoginPageProps) {
  const handleLogin = () => {
    const destination = new URL(basePath || '/', window.location.origin).toString();
    window.location.assign(`/cdn-cgi/access/login?redirect_url=${encodeURIComponent(destination)}`);
  };

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: '#faf7f0' }}>
      <div className="w-full max-w-sm mx-auto px-6">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl text-3xl mb-4"
            style={{ background: 'linear-gradient(135deg, #6366f1, #8b5cf6)', boxShadow: '0 8px 24px rgba(99,102,241,0.25)' }}>
            {appIcon}
          </div>
          <h1 className="text-2xl font-bold" style={{ color: '#2a2020' }}>
            {appName}
          </h1>
          <p className="text-sm mt-1" style={{ color: '#6b5b4e' }}>
            Conan Admin — Đăng nhập để tiếp tục
          </p>
        </div>

        {/* Login Card */}
        <div className="rounded-xl border p-6"
          style={{ background: 'white', borderColor: 'rgba(59,48,48,0.12)', boxShadow: '0 1px 3px rgba(0,0,0,0.04)' }}>

          <button
            onClick={handleLogin}
            className="w-full flex items-center justify-center gap-3 px-4 py-3 rounded-lg font-semibold text-sm transition-all"
            style={{
              background: '#2a2020',
              color: '#fff',
              cursor: 'pointer',
            }}
          >
              <>
                <ShieldCheckIcon className="size-5" />
                Đăng nhập qua Cloudflare Access
              </>
          </button>

          <div className="mt-4 text-center text-xs" style={{ color: '#9a8b7d' }}>
            Chỉ tài khoản quản trị được phép truy cập
          </div>
        </div>

        {/* Footer */}
        <div className="mt-6 text-center text-xs" style={{ color: 'rgba(107,91,78,0.4)' }}>
          Conan School v2.0 — Micro-Apps Architecture
        </div>
      </div>
    </div>
  );
}
